import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";

import { Paper, Container, Modal } from "@mui/material";

import TableTitle from "../../../UI/MaterialTableOverrides/TableTitle";
import Tree from "../../../UI/Tree/Tree";
import ModalPlaces from "../Modals/ModalPlaces";
import SiteSelector from "../../../UI/SiteSelector/SiteSelector";
import { i18n } from "../../../translate/i18n";

const Places = (props) => {
  const dispatch = useDispatch();
  let textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [limit, setLimit] = useState(5);
  // const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("place");
  const [order, setOrder] = useState("asc");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('root');
  const [modalEdit, setModalEdit] = useState(false);
  const [modalParent, setModalParent] = useState({});

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  const isSuperAdmin = useSelector(state => state.auth.superadmin)
  const fetchPlaces = useCallback(() => dispatch(actions.fetchPlaces(selectedSites)), [selectedSites]);
  const places = useSelector(state => state.places.places.rows);
  const searchText = useSelector(state => state.places.searchText);

  useEffect(() => {
    fetchPlaces(selectedSites)
  }, [selectedSites])

  useEffect(() => {
    return () => (
      dispatch(actions.clearCopyPlace())
    )
  }, [])

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])


  //type = root or branch or leaf
  //edit = true or false
  //parent = the parent node of the creating one (the actulal node you clicked)

  useEffect(() => {
    if (searchText !== "" || alreadySerched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          dispatch(actions.searchPlaces());
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    } else {
      dispatch(actions.searchPlaces());
    }
  }, [searchText, textInput]);

  const setOpenModal = (open, type, edit, parent) => {
    setIsModalOpen(open);
    setModalType(type);
    setModalEdit(edit);
    setModalParent(parent)
  }

  const selectSite = useCallback(
    (site) => dispatch(actions.selectSitePlaces(site))
  );

  return (
    <>
      <Container maxWidth="md">
        <Paper>
          <TableTitle
            title={i18n.t('tableTitlePlaces.title')}
            placeholder={i18n.t('tableTitleManagementEquip.placeholder')}
            inputRef={textInput}
            value={searchText}
            onChange={event => {
              setPage(1);
              dispatch(actions.searchTextPlaces(event.target.value));
            }}
            addRow={!isSuperAdmin ? false : () => setOpenModal(true, 'root', false, {})}
            helperTextSearch={i18n.t('tableTitleManagementEquip.helperTextSearch')}
          />

          <div style={{paddingLeft: 20}}>
            <SiteSelector selectedSites={selectedSites} selectSite={(site) => selectSite(site)}/>
          </div>
          <div style={styles.treeContainer}>
            <Tree
              {...props}
              nodes={places}
              openModal={(open, type, edit, parent) => setOpenModal(open, type, edit, parent)} />
          </div>
        </Paper>
      </Container>
      <Modal
        open={isModalOpen}
        onClose={() => setOpenModal(false, '')}
        style={styles.modal}
      >
        <ModalPlaces
          type={modalType} //root or branch or leaf
          edit={modalEdit} //edit
          parent={modalParent}
          closeModal={setOpenModal}
        />
      </Modal>
    </>
  );
}

export default Places;

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  treeContainer: {
    padding: 20,
    minHeight: 80,
  }
}
